import { dispatchGtagEvent } from "@/utils/google";

export const calculatorConversionSubmit = () => {
  dispatchGtagEvent("AW-11007046127/-lnXCKW7sLgaEO_jyIAp");
};
